import React, { useEffect, useState } from 'react'
import { Card, CardContent, Grid } from '@material-ui/core'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { ArrowLeftIcon } from 'asterX-UI/Icons'
import { useRoutes } from 'hooks'
import { HOME_PATH } from 'routes/constants.routes'
import { useWorkListViewSppStore } from 'context/WorkListViewStore/SPP/WorkListViewStore.spp'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { useStyles } from './work-list-view.styles'
import { AsterProgress } from 'asterX-UI/Progress/AsterProgress'
import AsterChip from 'asterX-UI/DataDisplay/AsterChip'
import { colorStatusesByCode } from 'constants/deals'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import TimerDiffDate from 'components/TimerDiffDate'
import clsx from 'clsx'
import PhoneView from 'components/PhoneView'
import { ERROR_COLORS } from 'asterX-UI'
import DiscountRequest from '../../../../../../components/Rop/DiscountRequest'
import CarImg from 'assets/img/car_placeholder.jpg'
import CardMedia from '@material-ui/core/CardMedia'
import { SppWorkListTabs } from '../SppWorkListTabs/SppWorkListTabs'
import { NotFound } from 'components/NotFound'
import { Modal } from 'asterX-UI/Modals'
import CarData from 'components/Desktop/Car/CarData'
import ActivityFeed from 'components/Desktop/WorkListView/ActivityFeed'
import { CarService } from 'lib/api'

export const SppWorkListView = () => {
  const classes = useStyles()
  const router = useRoutes()

  const {
    store: { wlData, contractData }
  } = useWorkListViewSppStore()

  const [activeCar, setActiveCar] = useState(null)
  const [openFeed, setOpenFeed] = useState(false)
  const [car, setCar] = useState({})

  const progressPercent =
    !!wlData?.contractStatusTrack?.current &&
    !!wlData?.contractStatusTrack?.total
      ? (wlData?.contractStatusTrack?.current /
          wlData?.contractStatusTrack?.total) *
        100
      : 0

  const handleCarClick = car => setActiveCar(car)

  const getCar = async () => {
    try {
      const response = await CarService.getCarByVin(wlData?.car.vin)
      setCar(response.data)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (wlData) {
      getCar()
    }
  }, [wlData])

  return (
    <Grid container className={classes.wlViewWrapper}>
      <Grid item xs={12} style={{ marginBottom: 24 }}>
        <AsterButton size="small" onClick={() => router.goTo(HOME_PATH)}>
          <ArrowLeftIcon />
          Назад
        </AsterButton>
      </Grid>
      <Grid item container alignItems="center" style={{ marginBottom: 24 }}>
        <Grid item>
          <AsterTypography variant="h6">
            РЛ: {wlData?.globalId || ''}
          </AsterTypography>
        </Grid>
        <Grid item style={{ margin: '0 35px' }}>
          <Card>
            <CardContent className={classes.statusProgressContent}>
              <Grid container>
                <Grid item xs={12}>
                  <AsterTypography variant="body2">
                    {wlData?.contractStatusTrack?.name || ''}
                  </AsterTypography>
                </Grid>
                <Grid item container alignItems="center">
                  <Grid item style={{ minWidth: 270 }}>
                    <AsterProgress
                      variant="determinate"
                      value={progressPercent}
                    />
                  </Grid>
                  <Grid item style={{ marginLeft: 12 }}>
                    <AsterTypography>
                      {[
                        wlData?.contractStatusTrack?.current || 0,
                        wlData?.contractStatusTrack?.total || 0
                      ].join('/')}
                    </AsterTypography>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          style={{
            marginLeft: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end'
          }}
        >
          <Grid item>
            <AsterChip
              label={wlData?.saleStatus?.name || '-'}
              style={{
                ...colorStatusesByCode(wlData?.saleStatus?.code)
              }}
              onClick={() => setOpenFeed(true)}
            />
          </Grid>

          {wlData?.carfinStatus?.name && (
            <Grid item>
              <AsterChip
                label={`ФС: ${wlData?.carfinStatus?.name || '-'}`}
                style={{
                  ...{
                    color: 'rgb(65, 111, 198)',
                    backgroundColor: 'rgb(245, 246, 255)'
                  }
                }}
                onClick={() => setOpenFeed(true)}
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid item container>
        <Grid
          item
          container
          className={clsx(classes.infoCard, classes.clientInfo)}
          spacing={4}
        >
          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Клиент'} labelStyle={{ minWidth: 136 }}>
              <AsterTypography>
                {clsx(wlData?.client?.firstName, wlData?.client?.lastName)}
              </AsterTypography>
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Филиал'} labelStyle={{ minWidth: 136 }}>
              <AsterTypography>{wlData?.branch?.name || '-'}</AsterTypography>
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Телефон'} labelStyle={{ minWidth: 136 }}>
              <PhoneView phone={wlData?.client?.phoneNumber || '-'} />
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Время РЛ'} labelStyle={{ minWidth: 136 }}>
              <TimerDiffDate date={wlData?.createdDate} />
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG
              label={'Выбранный банк'}
              labelStyle={{ minWidth: 136 }}
            >
              <AsterTypography>
                {contractData?.agreement?.product?.bank?.name || '-'}
              </AsterTypography>
            </FieldInfoNG>
          </Grid>

          <Grid item xs={12} md={6}>
            <FieldInfoNG
              label={'Менеджер'}
              rootStyle={{
                display: 'flex',
                alignItems: 'center'
              }}
              labelStyle={{ minWidth: 136 }}
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <AsterTypography>
                {wlData?.assignToFullName || '-'}
              </AsterTypography>{' '}
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Долг сделки'} labelStyle={{ minWidth: 136 }}>
              <AsterTypography
                style={{
                  color: ERROR_COLORS[600]
                }}
              >
                -
              </AsterTypography>
            </FieldInfoNG>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldInfoNG
              label={'Выбранные доп услуги'}
              rootStyle={{ display: 'flex', alignItems: 'center' }}
              labelStyle={{ minWidth: 136 }}
            >
              {contractData?.agreement?.additionalServices[0]?.name ? (
                <AsterTypography>
                  {`${
                    contractData?.agreement?.additionalServices[0]?.name || '-'
                  } - ${contractData?.agreement?.additionalServices[0]?.cost
                    ?.toString()
                    .thousandSeparator()} тг`}
                </AsterTypography>
              ) : (
                '-'
              )}
            </FieldInfoNG>
          </Grid>

          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Тип создания'} labelStyle={{ minWidth: 136 }}>
              <AsterTypography>{wlData?.creationType || '-'}</AsterTypography>
            </FieldInfoNG>
          </Grid>

          <Grid item xs={12} md={6}>
            <FieldInfoNG label={'Тип выкупа'} labelStyle={{ minWidth: 136 }}>
              <AsterTypography>{car.cpTransactionType || '-'}</AsterTypography>
            </FieldInfoNG>
          </Grid>
        </Grid>

        <Grid
          item
          container
          className={clsx(classes.infoCard, classes.carInfo)}
          onClick={() => {
            if (wlData?.car) {
              handleCarClick(wlData?.car)
            }
          }}
        >
          {wlData?.car ? (
            <>
              <Grid item xs={12} md={6} className={classes.carInfoWrapper}>
                <Grid item xs={12}>
                  <AsterTypography style={{ fontWeight: 600 }}>
                    {clsx(
                      wlData?.car?.marka,
                      wlData?.car?.model,
                      wlData?.car?.year
                    )}
                  </AsterTypography>
                </Grid>
                <Grid item xs={12}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className={classes.price}>{`${
                      (wlData?.car?.discountValue &&
                      wlData?.car?.discountApproveRopFullName
                        ? wlData?.car?.discountValue
                        : wlData?.car?.price
                      )
                        ?.toString()
                        ?.thousandSeparator() || '-'
                    } ₸`}</div>
                    {wlData?.car?.discountValue &&
                      wlData?.car?.discountApproveRopFullName && (
                        <div className={classes.discount}>{`${
                          wlData?.car?.price?.toString()?.thousandSeparator() ||
                          '-'
                        } ₸`}</div>
                      )}
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <AsterTypography>{wlData?.car?.vin || '-'}</AsterTypography>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 39 }}>
                  <AsterTypography>
                    {wlData?.car?.branch || '-'}
                  </AsterTypography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <CardMedia
                  component="img"
                  alt={clsx(
                    wlData?.car?.marka,
                    wlData?.car?.model,
                    wlData?.car?.year
                  )}
                  height={144}
                  style={{ borderRadius: 8 }}
                  image={
                    wlData?.car?.photos ? wlData?.car?.photos?.[0] : CarImg
                  }
                  title={clsx(
                    wlData?.car?.marka,
                    wlData?.car?.model,
                    wlData?.car?.year
                  )}
                />
              </Grid>
            </>
          ) : (
            <NotFound title="Нет выбранного авто" />
          )}
        </Grid>
      </Grid>
      {(![undefined, null].includes(wlData?.car?.discountAmount) ||
        ![undefined, null].includes(wlData?.car?.discountValue) ||
        ![undefined, null].includes(wlData?.car?.discountReason)) && (
        <Grid
          item
          container
          md={4}
          style={{
            marginTop: 10
          }}
        >
          <DiscountRequest
            car={wlData?.car}
            tradeInCarVin={wlData?.tradeInCarVin}
          />
        </Grid>
      )}

      <Grid item container style={{ marginTop: 10 }}>
        <SppWorkListTabs />
      </Grid>
      {activeCar?.vin && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={() => handleCarClick(null)}
        >
          <CarData vin={activeCar.vin} onClose={() => handleCarClick(null)} />
        </Modal>
      )}
      <ActivityFeed
        id={wlData?.id}
        open={openFeed}
        onClose={() => setOpenFeed(false)}
      />
    </Grid>
  )
}
